"use client";

import { Dialog, DialogBackdrop, DialogPanel } from "@headlessui/react";
import Button from "../commons/Button";

export default function DialogLoading({
  onClose = () => { },
  type = "loading", // 'loading', 'failed', or 'confirmation'
  title, // Dynamic title from outside
  message, // Dynamic message from outside
  iconSrc = "",
  buttonText = "Close",
  iconClassName = "w-[80px] h-[80px]",
  onButtonClick,
}) {
  const getIcon = () => {
    switch (type) {
      case "loading":
        return (
          <img
            src="/assets/icons/icon-loading.svg"
            className="animate-spin"
            alt="Loading"
          />
        );
      case "failed":
        return <img src="/assets/icons/icon-warning-circle.svg" alt="Failed" />;
      default:
        return iconSrc ? <img src={iconSrc} alt="Icon" className={iconClassName} /> : null;
    }
  };

  return (
    <Dialog open={true} onClose={onClose} className="relative z-[99999]">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-[#000] backdrop-blur-sm bg-opacity-75 transition-opacity"
      />

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto ">
        <div className="flex min-h-full items-center justify-center p-4 sm:p-0">
          <DialogPanel
            transition
            className="overflow-hidden product-ask-section border-style-decoration-white bg-[#141414] w-full max-w-[604px]"
          >
            <div className="relative flex h-full  min-h-[360px] flex-col justify-center items-center w-full">
              <img className="w-[10rem]" src="/assets/logos/logo.svg" alt="loading-logo" />

              <div className="relative mt-4 w-[10rem] h-1 bg-white">
                <div className="absolute top-0 w-[50%] h-1 bg-primary wider-animation" />
              </div>
            </div>
          </DialogPanel>
        </div>
      </div >
    </Dialog >
  );
}
